webpackJsonp([14],{

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'latest-notice',
  props: {
    notices: {
      type: Array,
      required: true,
      default: []
    }
  }
};

/***/ }),

/***/ 1480:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(333)(true);
// imports


// module
exports.push([module.i, ".timeList[data-v-36c89a46]{font-family:Barlow,sans-serif}.timeList li[data-v-36c89a46]{background:transparent}.timeList .notice-number[data-v-36c89a46]{width:1.5rem;height:1.5rem;background:#f8008e;color:#fff;font-size:.875rem}.timeList .list-start[data-v-36c89a46]{background:transparent}.timeList .list-start .badge[data-v-36c89a46]{font-family:Barlow,sans-serif;font-size:.875rem;background:#f8008e}.timeList .list-start .title[data-v-36c89a46]{text-transform:uppercase;font-family:Barlow,sans-serif;font-weight:700;font-size:.75rem;color:#979797}.timeList .list-start .timeSlop[data-v-36c89a46]{font-size:1.5rem;color:#fff;font-weight:700}", "", {"version":3,"sources":["/app/components/common/LatestNotice.vue"],"names":[],"mappings":"AAgCA,2BACE,6BAAkC,CACnC,AACD,8BACI,sBAAwB,CAC3B,AACD,0CACI,aAAc,AACd,cAAe,AACf,mBAAoB,AACpB,WAAe,AACf,iBAAoB,CACvB,AACD,uCACI,sBAAwB,CAC3B,AACD,8CACM,8BAAkC,AAClC,kBAAoB,AACpB,kBAAoB,CACzB,AACD,8CACM,yBAA0B,AAC1B,8BAAkC,AAClC,gBAAkB,AAClB,iBAAmB,AACnB,aAAe,CACpB,AACD,iDACM,iBAAkB,AAClB,WAAe,AACf,eAAkB,CACvB","file":"LatestNotice.vue","sourcesContent":["/*  Variable\n   ========================================================================== */\n/*  breakpoint\n   ========================================================================== */\n/*  Misc\n   ========================================================================== */\n/*  Section Colors\n   ========================================================================== */\n/*  The Big Guns\n   ========================================================================== */\n/*  The Next Wave\n   ========================================================================== */\n/*  Start Ups\n   ========================================================================== */\n/*  Future Tech\n   ========================================================================== */\n/*  Reviewed\n   ========================================================================== */\n/*  Tried & Tested\n   ========================================================================== */\n/*  Digital Life\n   ========================================================================== */\n/*  Other Colors\n   ========================================================================== */\n/*  Generic Colors\n   ========================================================================== */\n/*  Article Body Colors\n   ========================================================================== */\n/*  Footer\n   ========================================================================== */\n/*  AMP\n   ========================================================================== */\n.timeList[data-v-36c89a46] {\n  font-family: \"Barlow\", sans-serif;\n}\n.timeList li[data-v-36c89a46] {\n    background: transparent;\n}\n.timeList .notice-number[data-v-36c89a46] {\n    width: 1.5rem;\n    height: 1.5rem;\n    background: #F8008E;\n    color: #FFFFFF;\n    font-size: 0.875rem;\n}\n.timeList .list-start[data-v-36c89a46] {\n    background: transparent;\n}\n.timeList .list-start .badge[data-v-36c89a46] {\n      font-family: \"Barlow\", sans-serif;\n      font-size: 0.875rem;\n      background: #F8008E;\n}\n.timeList .list-start .title[data-v-36c89a46] {\n      text-transform: uppercase;\n      font-family: \"Barlow\", sans-serif;\n      font-weight: bold;\n      font-size: 0.75rem;\n      color: #979797;\n}\n.timeList .list-start .timeSlop[data-v-36c89a46] {\n      font-size: 1.5rem;\n      color: #FFFFFF;\n      font-weight: bold;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1569:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1480);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(884)("45ebf11a", content, true, {});

/***/ }),

/***/ 1739:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-group border-0 timeList latest-notice"
  }, [_vm._l((_vm.notices), function(res, index) {
    return [_c('div', {
      key: index,
      staticClass: "list-start border-0 pr-3 pl-3 pt-0 list-group-item list-group-item-action flex-column align-items-start"
    }, [_c('div', {
      staticClass: "d-flex w-100 justify-content-between"
    }, [_c('div', {
      staticClass: "mb-1 title"
    }, [_vm._v(_vm._s(res.title))])]), _vm._l((res.content), function(eachRes, looping) {
      return _c('li', {
        key: index + '-' + looping,
        staticClass: "border-0 w-100 p-0 pt-2 pb-2 list-group-item justify-content-between",
        attrs: {
          "gtm-on": "click",
          "gtm-event-action": "Menu/Click",
          "gtm-event-label": ("Menu/" + (eachRes.subTitle) + " (" + (res.title) + ")")
        }
      }, [_c('div', {
        staticClass: "timeSlop"
      }, [_vm._v(_vm._s(eachRes.subTitle))]), _c('div', {
        staticClass: "notice-number d-flex align-items-center rounded-circle"
      }, [_c('div', {
        staticClass: "mx-auto text-center"
      }, [_vm._v(_vm._s(eachRes.number))])])])
    })], 2)]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 888:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1569)
}
var Component = __webpack_require__(13)(
  /* script */
  __webpack_require__(1355),
  /* template */
  __webpack_require__(1739),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-36c89a46",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// 14.0b6b24bd826f4a449f13.js